import styled from 'styled-components/macro';
import { Divider } from '@material-ui/core';

export const StyledDivider = styled(Divider)`
  margin: 16px 0;
`;
